import React, { useState } from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/climate-tools/PageHeader'
import Layout from '../components/common/Layout'
import ClimateToolsGrid from '../components/data-sources/ClimateToolsGrid'

const ClimateTools = ({ data }) => {
  const climateTools = data.tools.nodes.flatMap((tool) => tool.frontmatter)

  const sortedTools = climateTools.sort((a, b) => {
    const titleA = a.title.toLowerCase()
    const titleB = b.title.toLowerCase()

    if (titleA < titleB) {
      return -1
    }
    if (titleA > titleB) {
      return 1
    }
    return 0
  })

  return (
    <Layout
      title="Tools for Climate and Nature Risk"
      meta={{
        description:
          'Discover the best open-access tools and platforms for climate and nature risk assessment, adaptation, and research',
        title: 'Tools for Climate and Nature Risk | Atlas Climate Tools',
        absoluteImageUrl: 'https://atlas.co/images/climate-tools-og.png',
        type: 'website'
      }}
    >
      <main>
        <PageHeader subtitle="Discover the best open-access tools and platforms for climate and nature risk assessment, adaptation, and research" />
        <ClimateToolsGrid data={sortedTools} />
      </main>
    </Layout>
  )
}

export default ClimateTools

export const pageQuery = graphql`
  query {
    tools: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/climate-tools/[^/]+\\.md$/" } }
      limit: 1000
    ) {
      nodes {
        id
        frontmatter {
          title
          excerpt
          tags
          featuredImage
        }
      }
    }
  }
`
